if (!customElements.get('tpt-creative-banner')) {
	customElements.define(
		'tpt-creative-banner',
		class TptCreativeBanner extends HTMLElement {
			constructor() {
				super();

				this.bannerItems = this.querySelectorAll('.tpt-creative-banner__item');

				this.bannerItems.forEach((banner) => {
					banner.addEventListener('mouseover', this.bannerHover.bind(this));
				});
			}

			bannerHover(event) {
				this.bannerItems.forEach((banner) => {
					banner.classList.remove('active');
				});

				event.currentTarget.classList.add('active');
			}
		}
	);
}
